module.exports = __webpack_public_path__ + "img/execution_iphone.b4ceebec.gif";